module.exports = __webpack_public_path__ + "static/media/acceptedStatus.46c83af7.svg";